import React from "react";
import { Box, Flex, Image, Text, List, ListItem } from "@chakra-ui/react";
import { motion } from "framer-motion";
import PriceList from "./Pricelist"; 

const MotionBox = motion(Box);
const MotionTextBox = motion(Box);

const sections = [
  {
    image: "images/beautyAlara1.webp",
    title: "Welkom bij Beauty ALARA",
    content: `Bij Beauty ALARA in Gent draait alles om uw welzijn. Met meer dan 20 jaar ervaring en een hoge klanttevredenheid bieden wij hoogwaardige behandelingen op maat. Onze gediplomeerde eigenares heeft een diepgaande kennis van huidverbetering en lichaamsverzorging. Elke klant krijgt een professionele en persoonlijke aanpak.`,
    direction: "left",
  },
  {
    image: "images/beautyAlara4.webp",
    title: "Ons aanbod",
    content: `Wij bieden een breed scala aan behandelingen, van laserontharing en gelaatsbehandelingen tot geavanceerde technieken zoals carbon laser peeling, microneedling en figuurcorrectie. Of u nu op zoek bent naar ontspanning met een lichaamsmassage, een oplossing voor acné of een behandeling om tatoeages of pigmentvlekken te verwijderen, wij helpen u graag om het beste uit uw huid en lichaam te halen.`,
    direction: "right",
  },
  {
  content: <PriceList />,
  direction: "left",
  fullWidth: true,
  noImage: true,
  earlyFade: true,  
},

  {
    image: "images/logo2.webp",
    title: "Onze gespecialiseerde diensten",
    content: (
      <>
        <Text mb={2} fontWeight="semibold">
          Medische en esthetische behandelingen
        </Text>
        <List spacing={1}>
          <ListItem>✔ Laserontharing</ListItem>
          <ListItem>✔ Verwijderen van tatoeages, pigmentvlekken en littekens</ListItem>
          <ListItem>✔ Plasma pen behandelingen</ListItem>
        </List>

        <Text mt={4} mb={2} fontWeight="semibold">
          Huidverzorging & huidverbetering
        </Text>
        <List spacing={1}>
          <ListItem>✔ Gelaatsbehandelingen</ListItem>
          <ListItem>✔ Acné behandeling</ListItem>
          <ListItem>✔ Hydrafacial behandeling</ListItem>
          <ListItem>✔ Carbon laser peeling</ListItem>
          <ListItem>✔ Microneedling (Derma pen)</ListItem>
        </List>

        <Text mt={4} mb={2} fontWeight="semibold">
          Lichaamsverzorging & ontspanning
        </Text>
        <List spacing={1}>
          <ListItem>✔ Lichaamsmassage & bindweefselmassage</ListItem>
          <ListItem>✔ Anti-cellulitis behandeling</ListItem>
          <ListItem>✔ Plaatselijke afslanking & cavitatie behandeling</ListItem>
          <ListItem>✔ Figuurcorrectie</ListItem>
        </List>
      </>
    ),
    direction: "left",
  },
];

const fadeInVariants = {
  left: {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0 },
  },
  right: {
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0 },
  },
};

const InfoSection = () => {
  return (
    <Box py={16} maxW="1400px" mx="auto" px={4}>
      {sections.map((section, index) => {
  const isImageLeft = section.direction === "left";
  const hasImage = !!section.image && !section.noImage;

  return (
    <MotionBox
      key={index}
      as={Flex}
      direction={{ base: "column", md: hasImage ? "row" : "column" }}
      align={section.fullWidth || section.noImage ? "stretch" : "center"}
      justify="space-between"
      mb={16}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: section.earlyFade ? 0.15 : 0.4 }}
      transition={{ duration: 0.8, ease: "linear" }}
      style={{ willChange: "opacity, transform" }}
      variants={fadeInVariants[section.direction]}
      gap={8}
      flexDir={
        hasImage
          ? isImageLeft
            ? { base: "column", md: "row" }
            : { base: "column", md: "row-reverse" }
          : "column"
      }
    >
      {hasImage && (
        <Image
          src={section.image}
          alt={section.title}
          width={{ base: "100%", md: "60%" }}
          height="auto"
          objectFit="cover"
          borderRadius="xl"
          shadow="lg"
        />
      )}

      <Box
        flex="1"
        px={section.fullWidth ? 0 : 4}
        width="100%"
        maxW={section.fullWidth ? "100%" : undefined}
      >
        <Text fontSize="2xl" fontWeight="bold" mb={4}>
          {section.title}
        </Text>

        {typeof section.content === "string" ? (
          <Text fontSize="md" color="gray.700">
            {section.content}
          </Text>
        ) : (
          <Box mt={2} width="100%">
            {section.content}
          </Box>
        )}
      </Box>
    </MotionBox>
  );
})}


      <MotionTextBox
        maxW="1000px"
        mx="auto"
        textAlign="center"
        mt={8}
        px={4}
        initial={{ opacity: 0, x: -100 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{
          duration: 0.8,
          ease: "linear"
        }}
        style={{ willChange: "opacity, transform" }}
      >
        <Text fontSize="md" mt={4}>
          Bij Beauty ALARA streven we naar een resultaatgerichte aanpak, waarbij we de nieuwste technologieën en methodes inzetten
          voor een optimale verzorging van uw huid en lichaam. Wij nemen graag de tijd om samen met u te kijken naar de beste behandeling
          die past bij uw wensen en huidtype.
        </Text>

        <Text fontSize="lg" mt={4} fontWeight="bold" color="pink.600">
          Uw schoonheid, onze passie! Boek vandaag nog een afspraak en ontdek hoe wij u kunnen helpen stralen!
        </Text>
      </MotionTextBox>
    </Box>
  );
};

export default InfoSection;
